import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFieldRichtext = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 28",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M0 0h48v48H0z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-8 -10)",
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "b",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8 26h32v4H8v-4zm0 8h20v4H8v-4zM8 10h32v4H8v-4zm0 8h32v4H8v-4z",
			fill: "#FFF",
			fillRule: "nonzero",
			mask: "url(#b)"
		})]
	})]
});
export default SvgFieldRichtext;
